import type { TFunction } from 'i18next';
import type { ClosedDayBookingResponse } from '../../api/generated';
import type { TableColumn } from '../UI';
import { actionsColumn, EMPTY, isSingleOccurrenceTime, reasonColumn } from '../Bookings/shared';
import { formatClosedDayPeriod, splitClosedDayOccurrence } from './closedDayTime';

interface ClosedDayBookingColumnHandlers {
  onEdit: (booking: ClosedDayBookingResponse) => void;
  onDelete: (booking: ClosedDayBookingResponse) => void;
}

const PERIOD_COL_WIDTH = 240;
const TIME_COL_WIDTH = 160;

const periodCell = (booking: ClosedDayBookingResponse): string =>
  isSingleOccurrenceTime(booking.time) ? formatClosedDayPeriod(booking.time) : EMPTY;

const timeCell = (t: TFunction, booking: ClosedDayBookingResponse): string => {
  if (!isSingleOccurrenceTime(booking.time)) return EMPTY;
  const split = splitClosedDayOccurrence(booking.time);
  return split.isFullDay ? t('booking-all-day') : `${split.startTime} – ${split.endTime}`;
};

export const getClosedDayBookingColumns = (
  t: TFunction,
  { onEdit, onDelete }: ClosedDayBookingColumnHandlers
): TableColumn<ClosedDayBookingResponse>[] => [
  {
    key: 'period',
    header: t('closed-day-col-period'),
    width: PERIOD_COL_WIDTH,
    render: (booking) => <span>{periodCell(booking)}</span>
  },
  {
    key: 'time',
    header: t('closed-day-col-time'),
    width: TIME_COL_WIDTH,
    render: (booking) => <span>{timeCell(t, booking)}</span>
  },
  reasonColumn(t, 'closed-day-col-reason'),
  actionsColumn(t, {
    editKey: 'closed-day-edit',
    deleteKey: 'closed-day-delete-title',
    onEdit,
    onDelete
  })
];
